import Vue from 'vue'

import App from '@/App.vue'
import { router } from '@/router/index.js'
import '@/plugins/bootstrap-vue.js'
import '@/assets/theme.scss'

Vue.config.productionTip = false

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
